export default __webpack_public_path__ + "static/media/README.7baa2ea8.md";